import * as libraryNameDefs from "../enums/libraryNames";
import * as libraryPriceLevels from "../enums/libraryPriceLevels";
import * as libraryServices from "../enums/libraryServices";
import * as stringUtil from "./stringUtil";
import find from "lodash.find";
import sortby from "lodash.sortby";

const strings = {
	plus: "Plus",
	appeals: "with Appeals",
};

export const REMOVE_TITLE = "remove";
const ADD_TITLE = "add";

export const libraryNames = [
	libraryNameDefs.PATENT,
	libraryNameDefs.COPYRIGHT,
	libraryNameDefs.TRADEMARK,
	libraryNameDefs.ANTITRUST,
	libraryNameDefs.TRADE_SECRET,
	libraryNameDefs.PROFILE,
	libraryNameDefs.SECURITIES,
	libraryNameDefs.UPC,
];

export function orderLibraries(commonLibraries) {
	const numberLibraries = libraryNames.length;

	return sortby(commonLibraries, lib => {
		const index = libraryNames.indexOf(lib.name);
		return index !== -1 ? index : numberLibraries;
	});
}

export function hasLibraryAccess(practiceAreas, libraryName) {
	if (!practiceAreas || !practiceAreas.length || !libraryName) {
		return false;
	}
	return !!find(practiceAreas, pa => pa.name === libraryName && pa.active === true);
}

export function getFirstActivePracticeArea(practiceAreas) {
	if (!practiceAreas || !practiceAreas.length) {
		return null;
	}

	const orderedLibraries = orderLibraries(practiceAreas).filter(lib => lib.active === true);
	return orderedLibraries.length ? orderedLibraries[0] : null;
}

export function getServiceTitle(service) {
	if (!service) {
		return null;
	}

	if (service === libraryServices.ANALYTICS) {
		return strings.plus;
	}

	if (service === libraryServices.APPEALS) {
		return strings.appeals;
	}

	return stringUtil.capitalizeFirst(service);
}

export function getRequestNewLibraryLevel(commonLibraries, groupLibraries, libraryName) {
	const patentLibrary = find(groupLibraries, l => l.name === libraryNames.PATENT);
	if (patentLibrary) {
		return patentLibrary.currentLevel;
	}

	if (groupLibraries.length) {
		return groupLibraries[0].currentLevel;
	}

	const library = find(commonLibraries, lib => lib.name === libraryName);
	return library ? library.pricing[0].title : ADD_TITLE;
}

export function getTitle(commonLibraries, libraryName) {
	if (!libraryName) {
		return libraryName;
	}

	if (!commonLibraries || !commonLibraries.length) {
		return stringUtil.capitalizeFirst(libraryName);
	}

	const library = find(commonLibraries, lib => lib.name === libraryName);
	return library ? library.title : stringUtil.capitalizeFirst(libraryName);
}

export function getFirstLibraryName(isAdmin, practiceAreas, groupLibraries) {
	if (isAdmin && groupLibraries && groupLibraries.length) {
		if (groupLibraries.length === 1) {
			return groupLibraries[0].name;
		}

		const sorted = orderLibraries(groupLibraries);
		return sorted[0].name;
	}

	const practiceArea = getFirstActivePracticeArea(practiceAreas);
	return practiceArea ? practiceArea.name : null;
}

export function getSingleUserServicePrice(pricing, service) {
	if (!pricing || !pricing.length || !service) {
		return 0;
	}

	const servicePrice = find(
		pricing,
		priceLevel =>
			priceLevel.title === libraryPriceLevels.SINGLE && priceLevel.service === service,
	);
	if (servicePrice) {
		return servicePrice.monthly_rate;
	}

	return 0;
}
